import { Injectable } from '@angular/core';
import { CustomerService, CustomerDto } from 'src/shared/service-proxies/service-proxies';

@Injectable({
  providedIn: 'root'
})
export class CachedCustomerServiceService {

  customers: CustomerDto[]

  constructor(private customerService: CustomerService) { }

  getAll(): Promise<CustomerDto[]> {
    return new Promise((resolve, reject) => {
      this.customerService.getAll().subscribe(data => {
        this.customers = data;
        resolve(data)
      });
    });
  }
}
